import React from 'react';
import { useContext, useMemo } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { StockLocationContext } from '../../../../../../context/StockLocationContext';
import { TranslationKey } from '../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../types/translation/Translator';
import { Routing } from '../../../../../../util/routes.util';
import { Breadcrumbs, Crumb, StockLocationSettingsCrumb } from '../../../../../components/Breadcrumbs';
import { Tab, Tabs } from '../../../../../components/Tabs';
import StockLocationBinsPane from './Bins/StockLocationBinPane';
import StockLocationDetailsPane from './Details/StockLocationDetailPane';
import StockLocationUsersPane from './Users/StockLocationUsersPane';
import StockLocationOrderPane from './Order/StockLocationOrderPane';
import { CompanyContext } from '../../../../../../context/CompanyContext';

export default function StockLocationUpdateScreen() {
  const id = useParams()['id'];
  if (!id) return null;

  const { currentCompany } = useContext(CompanyContext);
  const { stockLocations } = useContext(StockLocationContext);
  const stockLocation = useMemo(() => stockLocations.get(id), [id, stockLocations]);

  if (!stockLocation) return null;

  const showOrdersTab =
    currentCompany.settings.featureToggles.tasks.taskOrders.refill?.refill ||
    currentCompany.settings.featureToggles.kits?.refillKits;

  return (
    <div className='flex h-full flex-grow flex-col'>
      <Breadcrumbs>
        <StockLocationSettingsCrumb />
        <Crumb
          text={stockLocation.name}
          path={Routing.settings.stockLocations.update(stockLocation.id).locationDetails()}
          current
        />
      </Breadcrumbs>

      <div className='content-x content-y-breadcrumbs flex flex-grow flex-col gap-4 overflow-hidden'>
        <p className='section-title'>{stockLocation.name}</p>
        <div className='flex flex-grow flex-col overflow-hidden'>
          <Tabs>
            <Tab
              key={'location_details'}
              path={Routing.settings.stockLocations.update(stockLocation.id).locationDetails()}
              text={t(TranslationKey.locationDetails).singular.upper}
            />
            <Tab
              key={'bins'}
              path={Routing.settings.stockLocations.update(stockLocation.id).bins()}
              text={t(TranslationKey.bin).plural.upper}
            />
            <Tab
              key={'users'}
              path={Routing.settings.stockLocations.update(stockLocation.id).users()}
              text={t(TranslationKey.user).plural.upper}
            />
            {showOrdersTab ? (
              <Tab
                key={'orders'}
                path={Routing.settings.stockLocations.update(stockLocation.id).orders()}
                text={t(TranslationKey.order).plural.upper}
              />
            ) : null}
          </Tabs>
          <Routes>
            <Route path={'location_details'} element={<StockLocationDetailsPane stockLocation={stockLocation} />} />
            <Route path={'bins'} element={<StockLocationBinsPane stockLocation={stockLocation} />} />
            <Route path={'users'} element={<StockLocationUsersPane stockLocation={stockLocation} />} />
            <Route path={'orders'} element={<StockLocationOrderPane stockLocation={stockLocation} />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
